import React, { useState } from 'react';
import axios from 'axios';
import Dropdown from 'react-bootstrap/Dropdown';
import { Modal, Button } from 'react-bootstrap';





function PostSupprimer(props) {
    const [confirmation, setConfirmation] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;



    const handleSubmitSupp = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setConfirmation(false);
        
        try {
          await axios.delete(
            `${apiUrl}/post/supprimer`,
            {
                withCredentials: true, // Inclut les cookies dans la requête
                data: {
                    idPost : props.post.id_post,
                    idAuteur : props.userData.user.donnée.results[0].id,
                    Type : props.type
                }
            }
        );

    
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
            window.location.reload(); 

        }
      };

      if (isLoading) {
        return (
            <div className="centered-content">
                <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                <br/>
                <span className="loader"></span>
            </div>
        );  
    }


  return (
    
    <>
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => setConfirmation(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>Confirmer la suppresion du post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Voulez-vous vraiment supprimer le post ?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => setConfirmation(false)} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmitSupp(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    {props.userData && (
      <>
                <div className="dropdown-container" style={{marginLeft:'auto'}}>
                    <Dropdown align="end" >
                        <Dropdown.Toggle variant="secondary" id="dropdown-basic"  style={{backgroundColor: 'transparent', border: 'none', color: 'black'}}>
                            ...
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={()=> setConfirmation(true)}>Supprimer votre post</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

    </>
  )}

 </>) 

}

export default PostSupprimer;
